// extracted by mini-css-extract-plugin
export default {"alignVertically":"VerticallyAlignedSpinner_alignVertically__Sv3tP"};